import { store } from "@redux/store"
import { format } from "./helpers"

export function generatePlanOver(){
    const porductData = store.getState().everGreenStep1.staticData
    const quotation = store.getState().everGreenStep1.quotation
    const yearList = quotation.sqsquotation.surrenderValueList.reduce((acc, item)=>{
        
        acc[0]+=`<li>Year ${item.year}</li>`
        acc[1]+=`<li>S$${format(item.amount)}</li>`

        return acc


    },["",""])
    const planData = {
        planoverview:  [
         {
           heading: { text: 'Plan Overview' },
           descriptions: [
             { text: 'Plan Selected', value:porductData.productName },
             { text: 'Selected Amount', value: `S$${format(quotation.investingAmount)}`},
           ],
         },
         {
           heading: { text: 'Policy Value and Benefits Overview' },
           descriptions: [
             {
               text: `<div><p>Cash Surrender Value</p>
               <ul class="evergreen-productoverview">
                 ${yearList[0]}
               </ul>
               </div>`,
               value: `<div>
               <p>&#160</p>
               <ul class="evergreen-productoverview-value">
               ${yearList[1]}
             </ul>
               
               </div>`,
             },
             {
               text: '<p>Death Benefit</p>',
               value: `S$${format(quotation.sqsquotation.deathBenefit)}`,
             },
             {
               text: '<p>Maturity Benefit</p>',
               value: `S$${format(quotation.sqsquotation.maturityPayout)}`,
             },  
           ],
           
         },
       ],
       summary:{
         text: 'Single Premium',
         value: `S$${format(quotation.investingAmount)}`
       }
     
     }

     return planData
}